import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../stateProvider/StateProvider';
import Icon from '../forms/Icon';
import Checkbox from '../forms/Checkbox';
import Heading from '../forms/Heading';
import { generateId } from '../utility/functions';


const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
    border-radius: 2em;
    transition: 0.2s;
    flex: 1;

    // padding: 0.2em;
    padding-left: ${({ noPadding }) => !noPadding ? '0.5em' : ''};

    &:hover {
        background: ${({ noHover, theme }) => !noHover ? (theme.gray + '1a') : ''};
    }
`;

const ThemeWrapper = styled.div`
    position: relative;
    color: ${({ theme }) => theme.active};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const I = styled(Icon)`
    position: absolute;
    font-size: 0.7em;
    z-index: 1;
    transition: all 0.2s;
    pointer-events: none;
    left: ${({ checked }) => checked ? '15%' : '55%'};
`;
const Theme = styled(Checkbox)`
    background: ${({ theme }) => theme.gray} !important;
`;

const ThemeSelector = ({ children, ...props }) => {
    const {
        state: {
            dark_theme
        },
        toggleTheme
    } = useGlobalState();

    const id = generateId()

    return (
        <Wrapper
            onClick={() => toggleTheme()}
        >
            <Heading
                fontSize={0.8}
                htmlFor={id}
                style={{ width: '90%', lineHeight: '2em', cursor: 'pointer' }}
                label={'Theme'}
            />
            <ThemeWrapper>
                <I icon={dark_theme ? 'sun' : 'moon'} checked={dark_theme} />
                <Theme
                    standalone
                    htmlFor={id}
                    checked={dark_theme}
                    id='themeSelector'
                    readOnly
                    noHover
                    noPadding
                />
            </ThemeWrapper>
        </Wrapper>
    );
}

export default ThemeSelector;
